import { Component, OnInit } from '@angular/core';
import { TopicService } from '../../service/topic.service';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Globals } from '../../globals';
import {commonService} from "../../service/common.service";
@Component({
  selector: 'app-posttopic',
  templateUrl: './posttopic.component.html',
  styleUrls: ['./posttopic.component.css'],
  providers:[TopicService,Globals,commonService]
})
export class PosttopicComponent implements OnInit {
  start:any;
  end:any=10;
  pageSize = 10;
  serach:any;
  topiclist:any;
  totalrow:0;
  notfound:any;
  msg="";
  isError:boolean;
  currentPage = 0;
  //isSuccess:false;
  pageEvent:any;
 
  isSuccess=false;

  constructor(private topicservice:TopicService,public router: Router, private global: Globals,private commonService:commonService) { }

  ngOnInit() {
    this.gettopiclist();
    if(localStorage.getItem('isSuccess')=="Yes"){
      this.isSuccess=true;
      this.msg =    localStorage.getItem('msg');
      localStorage.removeItem('isSuccess');
      localStorage.removeItem('msg');
    }
  }
  // paging handle
  handlePage(e: any){
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.end =  this.pageSize;
    this.start = this.currentPage * this.pageSize; 
    this.gettopiclist()    
  }
  

  gettopiclist(){
    let obj={}
    obj['limit']=this.end;
    obj['offset']=this.start;
    obj['search']=this.serach;

    this.topicservice.gettopiclist(obj).subscribe((data : any)=>{
            if(data.error==0){ 
              this.topiclist = data.results.rows;
            //  console.log(this.topiclist);   
              this.totalrow = data.results.count;
              if(this.totalrow==0){
                this.notfound=true;
              }else{
                this.notfound=false;
              }
            }else{
              if(data.message=="Failed to authenticate token."){
                this.router.navigate(['/admin']);
              }else{
               this.msg = data.message;
               this.isError = true;
              }
            }
     },
       (error : HttpErrorResponse)=>{
         this.isError = true;
         this.msg="internal server error!";
       });
  
}
filterform(searchtxt){
  var txt = searchtxt.value.search.trim();
  
  //this.router.navigateByUrl('/admin/discussion/topic?search='+txt);
  
  this.serach=txt;
  this.start=0;
  this.gettopiclist();  
}

    getTopicImage(imagename){
      if(imagename!=""){
      return this.global.topicImageUrl+imagename;
      }else{
      return this.global.topicImageUrl+'topic.png';
      }
    }

    customEnode(data){
      return encodeURI(btoa(data));
    }

    deltopic(id,index){

     let r =confirm('do you want to delete?');
     if(r==true){
      let obj={};
      obj['id']=parseInt(id);
      this.topicservice.deletetopic(obj).subscribe((data:any)=>{
        if(data.error==0){
          this.topiclist.splice(index,1);
          this.totalrow -=1;
        }
      },(error:HttpErrorResponse)=>{
        this.isError = true;
        this.msg="internal server error!";
      })

     }else{

      console.log('not deleted');
     }
    }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/discussion/posttopic/posttopic.component.ts